import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  min-height: 300px;
  max-height: 600px;
  overflow-y: auto;
`;
